import { Tooltip } from "@chakra-ui/react";
import { Avatar } from "@src/components/ui-kit/Avatar";
import { formatPhone } from "@src/utils/formatters";
import type React from "react";
import type { FC } from "react";

export const UserCard: FC<
  React.PropsWithChildren<{
    email?: string;
    imageSource?: string | null;
    name: string;
    phone?: string;
    teamName?: string;
    avatarBg?: string | null;
  }>
> = ({ email, imageSource, name, teamName, phone, avatarBg }) => {
  return (
    <div className="flex">
      <div>
        <Avatar
          name={name}
          src={imageSource}
          colorScheme={avatarBg ?? undefined}
        />
      </div>

      <div className="ml-4">
        <p className="text-2xl font-bold">{name}</p>
        {!!teamName && <p className="text-xl">{teamName}</p>}
        {!!email && email.length > 15 ? (
          <Tooltip label={email}>
            <p className="text-xl">{`${email.slice(0, 15)}...`}</p>
          </Tooltip>
        ) : (
          <p className="text-xl">{email}</p>
        )}
        {!!phone && <p className="text-xl">{formatPhone(phone)}</p>}
      </div>
    </div>
  );
};
